import Layout from '@/components/layout/Layout';
import { FC } from 'react';
import Link from 'next/link';
import BookCardItemAuthor from '@/components/ui/book-card-item/BookCardItemAuthor';
import Pagination from '@/components/ui/pagination/Pagination';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';
import { getAuthorFullName } from '@/helpers/helpers';
import { IAuthorDetail } from '@/interfaces/authorDetail.interface';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import styles from './AuthorsDetail.module.scss';

interface IAvthorDetailProps extends IWidgetsSideBar {
  books: IAuthorDetail;
}

const AuthorsDetail: FC<IAvthorDetailProps> = ({ books, todayWidget, popularBooksWidget }) => {
  const pagesCount = Math.ceil(books.books_count / BOOKS_FOR_PAGE);
  const pageUrl = useGetUrlPath();
  const bookPage = pageUrl.includes('/page=') ? Number(pageUrl.split('/page=')[1]) : 1;

  const authorData = books.base_author_data;
  const authorFullName = getAuthorFullName(authorData.first_name, authorData.middle_name, authorData.last_name);

  const SEO_TITLE = `${authorFullName} книги - скачать бесплатно в fb2, книги автора «${authorFullName}» читать онлайн`;
  const SEO_DESCRIPTION = `Все книги автора ${authorFullName} в библиотеке BookZ. ✔️ Скачать бесплатно в формате fb2, epub, pdf. ✔️ Читать онлайн на сайте.`;
  const SEO_CANONICAL = `/authors/${books.alias}`;

  return (
    <Layout
      title={SEO_TITLE}
      description={SEO_DESCRIPTION}
      canonicalHref={SEO_CANONICAL}
      pageHref={pageUrl}
      breadcrumbs={<Breadcrumbs firstPageName="Полный список авторов библиотеки" firstPageAlias="/authors/" secondPageName={authorFullName} />}
      todayWidget={todayWidget}
      popularBooksWidget={popularBooksWidget}
    >
      <SectionTitle name={`Книги автора ${authorFullName}`} />
      <>
        {books.series.map((series, index) => (
          <div key={series.series_alias}>
            <div className={index === 0 ? `${styles.authorSeries} ${styles.authorSeries_first}` : `${styles.authorSeries}`}>
              <span className={styles.authorSeries__item}>
                {series.series_title.length > 0 && series.series_title !== 'Без серии' ? (
                  <>
                    Cерия:{' '}
                    <Link prefetch={false} href={`/seria-knig/${series.series_alias}`} className={styles.authorSeries__link}>
                      {series.series_title}
                    </Link>
                  </>
                ) : (
                  'Без серии'
                )}
              </span>
            </div>
            <div>
              {series.books.length > 0 ? (
                series.books.map((book) => (
                  <BookCardItemAuthor
                    authorAlias={books.alias}
                    createdAt={String(book.satellite_book?.created_at)}
                    alias={String(book.satellite_book?.alias)}
                    author={authorData}
                    book={book}
                    key={book.id}
                    rating={Number(book.satellite_book?.rating)}
                  />
                ))
              ) : (
                <div>Книги не найдены</div>
              )}
            </div>
          </div>
        ))}
      </>
      <Pagination pagesCount={pagesCount ?? 0} postName={`authors/${books.alias}/page=`} />
    </Layout>
  );
};

export default AuthorsDetail;
